/* eslint-disable */
import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../SEO';
import posts from './posts';

const CATEGORY_LABELS = {
  'storage-tips': 'Storage Tips',
  'moving-advice': 'Moving Advice',
  'company-updates': 'Company Updates',
  'local-content': 'SF & Bay Area',
  'city-guides': 'City Guides',
};

const pageContainer = {
  minHeight: '100vh',
  backgroundColor: '#261136',
  padding: 24,
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
};

const shellCard = {
  width: '100%',
  maxWidth: 900,
  background: 'radial-gradient(circle at top, #3A1F52 0, #170824 45%, #12061f 100%)',
  borderRadius: 16,
  padding: '32px 32px 48px',
  boxSizing: 'border-box',
  boxShadow: '0 18px 45px rgba(0,0,0,0.45)',
  color: '#F5F5FA',
};

const pageTitle = {
  fontSize: 32,
  fontWeight: 700,
  color: '#F5F5FA',
  marginBottom: 8,
};

const pageSubtitle = {
  fontSize: 16,
  color: '#AAB5E0',
  marginBottom: 40,
};

const categoryBadge = {
  display: 'inline-block',
  background: 'rgba(170,181,224,0.15)',
  color: '#AAB5E0',
  fontSize: 12,
  fontWeight: 600,
  letterSpacing: '0.05em',
  textTransform: 'uppercase',
  padding: '3px 10px',
  borderRadius: 20,
  marginBottom: 10,
};

const postCard = {
  display: 'block',
  background: 'rgba(255,255,255,0.04)',
  border: '1px solid rgba(255,255,255,0.08)',
  borderRadius: 12,
  padding: '24px 28px',
  marginBottom: 20,
  textDecoration: 'none',
  color: 'inherit',
  transition: 'background 0.15s',
};

const postTitle = {
  fontSize: 20,
  fontWeight: 600,
  color: '#F5F5FA',
  marginBottom: 8,
  lineHeight: 1.35,
};

const postMeta = {
  fontSize: 13,
  color: '#AAB5E0',
  marginBottom: 10,
};

const postExcerpt = {
  fontSize: 14,
  color: 'rgba(245,245,250,0.75)',
  lineHeight: 1.6,
};

const emptyState = {
  textAlign: 'center',
  color: '#AAB5E0',
  padding: '60px 0',
  fontSize: 16,
};

const BlogIndex = () => {
  const sorted = [...posts].sort((a, b) => new Date(b.date) - new Date(a.date));

  const formatDate = (dateStr) => {
    const d = new Date(dateStr + 'T12:00:00');
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  return (
    <>
      <SEO
        title="Bins Storage Blog | Storage Tips, Moving Advice & Bay Area Guides"
        description="Expert storage tips, moving advice, and local guides for the San Francisco Bay Area from Bins — your full-service valet storage solution."
        path="/blog"
        type="website"
      />
      <div style={pageContainer}>
        <div style={shellCard}>
          <h1 style={pageTitle}>The Bins Blog</h1>
          <p style={pageSubtitle}>
            Storage tips, moving advice, and Bay Area guides from the Bins team.
          </p>

          {sorted.length === 0 ? (
            <div style={emptyState}>New posts coming soon — check back weekly!</div>
          ) : (
            sorted.map((post) => (
              <Link key={post.slug} to={`/blog/${post.slug}`} style={postCard}>
                <div style={categoryBadge}>
                  {CATEGORY_LABELS[post.category] || post.category}
                </div>
                <div style={postTitle}>{post.title}</div>
                <div style={postMeta}>{formatDate(post.date)}</div>
                <div style={postExcerpt}>{post.description}</div>
              </Link>
            ))
          )}
        </div>
      </div>
    </>
  );
};

export default BlogIndex;
